import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import classnames from 'classnames';
import { isValidElement } from 'react';
import styles from './searchResult.module.scss';
/**
 * Represents a component that is used to render a single result on the search
 * results sidebar
 */
export const SearchResult = ({ className, content, onClick, }) => {
    const renderContent = () => {
        if (isValidElement(content)) {
            return content;
        }
        const { avatar, message, title } = content;
        return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: styles.avatar }, { children: avatar })), _jsxs("div", Object.assign({ className: styles.resultContent }, { children: [_jsx("div", Object.assign({ className: styles.title }, { children: title })), _jsx("div", Object.assign({ className: styles.message }, { children: message }))] }))] }));
    };
    return (_jsx("div", Object.assign({ className: classnames(styles.result, className), onClick: onClick }, { children: _jsx("div", Object.assign({ className: styles.resultCenter }, { children: renderContent() })) })));
};
